import React from 'react';

import { FileType } from '~/util/constants';
import {
  ImportContactsFileFormat,
  ImportContactsV2MutationVariables,
} from '~/graphql/types';
import Overlay from '~/components/organism/ModalsV2/Overlay';
import Modal from '~/components/organism/ModalsV2/Modal';
import { Heading3 } from '~/components/atom/Typography';
import JustificationContainer from '~/components/atom/JustificationContainer';
import ImportContactsContent from './components/ImportContactsContent';
import ImportContactsSuccess from './components/ImportContactsSuccess';
import { WorkflowStepType } from '../..';

const text = {
  header: 'Importeer contacten',
  importContactsSuccess: 'Contacten worden geïmporteerd',
};

export type Props = {
  onClose: () => void;
  allowedFileExtensions: Array<FileType>;
  loading: boolean;
  fileFormat: ImportContactsFileFormat;
  workflowStep: WorkflowStepType;
  onAddMore: () => void;
  onImport: (
    variables: ImportContactsV2MutationVariables,
  ) => Promise<{ errors: Array<string> | null; success: boolean }>;
};

const MODAL_WIDTH = '650px';
const ImportContactsModal: React.FCC<Props> = ({
  dataTestId,
  onClose,
  workflowStep,
  onAddMore,
  ...rest
}) => (
  <Overlay dataTestId={dataTestId} onClose={onClose} root="import-contacts">
    <Modal maxWidth={MODAL_WIDTH} onClose={onClose}>
      <JustificationContainer
        align="center"
        direction="column"
        padding={['xl']}
        margin={['m']}
      >
        {workflowStep === 'MULTIPLE_CONTACTS' ? (
          <>
            <Heading3 color={{ group: 'primary' }}>{text.header}</Heading3>
            <ImportContactsContent {...rest} onClose={onClose} />
          </>
        ) : (
          <>
            <Heading3 color={{ group: 'primary' }}>
              {text.importContactsSuccess}
            </Heading3>
            <ImportContactsSuccess onClose={onClose} onAddMore={onAddMore} />
          </>
        )}
      </JustificationContainer>
    </Modal>
  </Overlay>
);

export default ImportContactsModal;
